import React from 'react';
import PropTypes from 'prop-types';
import DragSwipe from '@cotyorg/ccx-utils/js/components/DragSwipe';

const onSwipe = ({
  carouselsStoreDataKey,
  currentIndex,
  setIndex,
  sliderRef,
}) => ({ direction }) => {
  if (direction === 'right') {
    setIndex({ carouselsStoreDataKey, index: currentIndex - 1 });
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(currentIndex - 1);
    }
  } else if (direction === 'left') {
    setIndex({ carouselsStoreDataKey, index: currentIndex + 1 });
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(currentIndex + 1);
    }
  }
};

const CarouselSwiper = ({
  children,
  setIndex,
  carouselsStoreDataKey,
  currentIndex,
  sliderRef,
}) => (
  <DragSwipe
    onSwipe={onSwipe({
      carouselsStoreDataKey,
      currentIndex,
      setIndex,
      sliderRef,
    })}
  >
    {children}
  </DragSwipe>
);

CarouselSwiper.propTypes = {
  children: PropTypes.node.isRequired,
  setIndex: PropTypes.func.isRequired,
  carouselsStoreDataKey: PropTypes.string.isRequired,
  currentIndex: PropTypes.number.isRequired,
  sliderRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

export default CarouselSwiper;
